import { configureStore } from '@reduxjs/toolkit'
import pageIdReducer from '../features/pageIdSlice'

export default configureStore({
  reducer: {
    pageId: pageIdReducer,
  },
})